import { render, staticRenderFns } from "./ShiftPeriodsOverview.vue?vue&type=template&id=437b224d&"
import script from "./ShiftPeriodsOverview.vue?vue&type=script&lang=js&"
export * from "./ShiftPeriodsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ShiftPeriodsOverview.vue?vue&type=style&index=0&id=437b224d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports